export class PDAUser {
  pda_User_Id = 0;
  firstname = '';
  lastname = '';

  pin = '';

  expired = false;
  created_Date = '';
  tag_Id_Text = '';

  pda_User_Type_Id = 0;
  pda_User_Type_Name = '';

  company_Id = 0
  company_Name = '';

  android_Pin = '';
  confirm_Android_Pin = '';
  rfid_Enabled = false;
  login_Attempts = 0;
  locked_Out = false;

  is_edit = false;
}
